import React, { useCallback, useEffect, useState } from 'react';
import { Container, Col, Row, Button, Form, Alert } from 'react-bootstrap';
import { DndProvider } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/esm/HTML5toTouch';
import DndList from '../../Components/DndList';
import DOMPurify from 'dompurify';
import { useIntl, defineMessages } from 'react-intl';

import { FormattedMessage } from 'react-intl';

const ElaborateQuestion = ({
    result,
    setResult,
    question,
    elaboration,
    setElaboration,
    random,
    page,
    setPage
}) => {
    const [required, setRequired] = useState([]);
    const [tmpText, setTmpText] = useState([]);
    const [wordCount, setWordCount] = useState(0);
    const intl = useIntl();
    const messages = defineMessages({
        enterHere: {
            id: 'Instruction.enterHere',
            defaultMessage: 'Enter Here'
        },
        atLeastWords: {
            id: 'New1.atleast',
            defaultMessage: 'Please explain with at least 100 words'
        }
    });
    useEffect(() => {
        const req = [];
        const t = [];
        for (let q in question) {
            req.push(false);
            t.push('');
        }
        setRequired(req);
        setTmpText(t);
    }, [question]);
    useEffect(() => {
        setPage(0);
        setWordCount(0);
    }, [question]);
    const setText = useCallback((a) => {
        setResult(a);
    }, []);

    const getPage = useCallback(() => {
        const number = question.numberOfElatorations;
        if (page === 0) {
            return (
                <Container>
                    <Row>
                        <Col
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(question.listTitle)
                            }}
                        ></Col>
                    </Row>
                    {[...Array(number).keys()].map((key, index) => {
                        if (!result) {
                            return;
                        }
                        return (
                            <Row className="my-3" key={key}>
                                <Col xs={2}>{key + 1}</Col>
                                <Col>
                                    <Form.Control
                                        placeholder={intl.formatMessage(
                                            messages.enterHere
                                        )}
                                        value={result[key]}
                                        isInvalid={required[index]}
                                        onChange={(e) => {
                                            setRequired((old) => {
                                                const newObj = [...old];
                                                newObj[key] = false;
                                                return newObj;
                                            });

                                            if (
                                                !e.target.value &&
                                                e.target.value !== ''
                                            ) {
                                                return;
                                            }

                                            const value = e.target.value;
                                            setResult((old) => {
                                                const newRes = [...old];
                                                newRes[key] = value;
                                                return newRes;
                                            });
                                            setTmpText((old) => {
                                                const newObj = [...old];
                                                if (value) {
                                                    newObj[key] = value;
                                                }
                                                return newObj;
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                        );
                    })}
                </Container>
            );
        } else if (page === 1) {
            return (
                <Container>
                    <Row>
                        <Col>{question.rankTitle}</Col>
                    </Row>
                    <Row>
                        <Col>
                            <DndProvider options={HTML5toTouch}>
                                <DndList cards={result} setCards={setText} />
                            </DndProvider>
                        </Col>
                    </Row>
                </Container>
            );
        } else if (page === 2) {
            return (
                <Container>
                    <Row>
                        <Col>{question.elaborateTitle}</Col>
                    </Row>

                    <Row>
                        <Col>
                            <Container>
                                <Row className="text-left">
                                    <Col className="text-center h6 mt-3">
                                        {result[random]}
                                    </Col>
                                </Row>
                                <Row>
                                    {wordCount > 1 && wordCount < 100 && (
                                        <Col>
                                            <Alert
                                                variant="warning"
                                                dismissible
                                            >
                                                Veuillez répondre avec au moins
                                                100 mots
                                            </Alert>
                                        </Col>
                                    )}
                                </Row>
                                <Row className="my-2">
                                    <Col xs={{ offset: 0, span: 12 }}>
                                        <Form.Control
                                            className="form-control"
                                            as="textarea"
                                            rows={6}
                                            placeholder={intl.formatMessage(
                                                messages.atLeastWords
                                            )}
                                            isInvalid={wordCount < 100}
                                            value={elaboration}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value) {
                                                    const length =
                                                        value.split(' ').length;
                                                    setWordCount(length);
                                                }
                                                setElaboration(e.target.value);
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            );
        } else {
            return <div>invalid</div>;
        }
    }, [page, question, result, elaboration, required, wordCount]);

    const getButtons = useCallback(() => {
        if (page < 2) {
            return (
                <>
                    <Row>
                        <Col xs={12} md={5} className="text-left">
                            <FormattedMessage
                                id="Elaborate.instructionNextPart"
                                defaultMessage="(Click on Next to go to the next part)"
                            />
                        </Col>
                        <Col xs={12}>
                            <Button
                                className="w-100"
                                variant="outline-success"
                                disabled={page >= 2}
                                onClick={() => {
                                    if (page === 0) {
                                        let key = 0;
                                        let allClear = true;
                                        const newArr = [];
                                        for (let i of tmpText) {
                                            if (i === '') {
                                                allClear = false;

                                                newArr.push(true);
                                            } else {
                                                newArr.push(false);
                                            }
                                            key += 1;
                                        }
                                        setRequired(newArr);
                                        if (!allClear) {
                                            return;
                                        }
                                    }

                                    setPage((old) => old + 1);
                                }}
                            >
                                <FormattedMessage
                                    id="Next"
                                    defaultMessage="Next"
                                />
                            </Button>
                        </Col>
                    </Row>
                </>
            );
        }
    }, [page, tmpText]);

    return (
        <Container>
            <Row>
                <Col>{getPage()}</Col>
            </Row>
            <Row>
                <Col>{getButtons()}</Col>
            </Row>
        </Container>
    );
};

export default ElaborateQuestion;
